import Vue from "vue";
import App from "./App.vue";
import router from "./router"; // 路由
import './router/permission'; // 加载路由权限控制
import store from "./store";
import '@babel/polyfill' // 解决ie兼容问题
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import VueDND from 'awe-dnd'
import 'windi.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/directive/directive.js";

import animated from 'animate.css/animate.css'
Vue.use(animated);

import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)

// import globalVariable from './plugins/global'
// Vue.use(globalVariable)

import plTable from 'pl-table'
import 'pl-table/themes/index.css' // 引入样式（必须引入)，vuecli3.0不需要配置，cli2.0请查看webpack是否配置了url-loader对woff，ttf文件的引用,不配置会报错哦
import 'pl-table/themes/plTableStyle.css' // 默认表格样式很丑 引入这个样式就可以好看啦（如果你不喜欢这个样式，就不要引入，不引入就跟ele表格样式一样）
Vue.use(plTable);

// 自定义主题
// import './css/theme.less';
import "./css/public.less"; // 公共css样式
import "./css/global.less"; // 公共css样式
import "./css/element.less";
Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.use(VueDND);

import WiseUi from "@wise/element-ui"
import '@wise/element-ui/lib/ui.css'
import '@wise/element-ui/lib/global-and-cover.css'
Vue.use(WiseUi)


Vue.prototype.$message = function(msg){
	ElementUI.Message({ ...msg, duration: 2000, showClose: true, })
    
}

// 工具
import {backPage, isNotNull, isBlank} from "./utils/util";
// 按钮组件级别权限校验
import checkPermission from "./utils/permission";
// 配置文件
import {indexPage, loginPage} from "./config/config";

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);

// 引入mock文件 目前登录使用的是在线mock
// require('./mock/index') // mock 方式，正式发布时，注释掉该处即可

Vue.prototype.$backPage = backPage
Vue.prototype.$isNotNull = isNotNull
Vue.prototype.$isBlank = isBlank
Vue.prototype.$indexPage = indexPage
Vue.prototype.$loginPage = loginPage
Vue.prototype.$checkPermission = checkPermission

Vue.config.productionTip = false;

/*
限制输入框只能输入自然数，0,1,2,3,
v-natural-number
*/
import onlyNumber from './directive/onlyNumber'
Vue.directive('floatNumber', onlyNumber)
Vue.directive('naturalNumber', {
	inserted: function (el) {
    el.addEventListener('keypress', function (e) {
    e = e || window.event
    let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
    let re = /^[0-9][0-9]*$/
    if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
        if (e.preventDefault) {
        e.preventDefault()
        } else {
        e.returnValue = false
        }
    }
    })
	}
})


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
